import { render, staticRenderFns } from "./CompareModalData.vue?vue&type=template&id=1807c456&scoped=true"
import script from "./CompareModalData.vue?vue&type=script&lang=js"
export * from "./CompareModalData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1807c456",
  null
  
)

export default component.exports